import type { User } from '../types';

// The public header only needs the current session, not the entire API client.
export async function fetchCurrentSession(): Promise<{ user: User | null }> {
  const response = await fetch(`/api/auth/me?_t=${Date.now()}`, {
    credentials: 'include',
    cache: 'no-store',
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      Pragma: 'no-cache',
      Expires: '0',
    },
  });
  if (!response.ok) {
    throw Object.assign(new Error(`Session request failed: ${response.status}`), {
      response: { status: response.status },
    });
  }
  return response.json();
}
